import useCancelToken from "./UseCancelToken"
import { post_get_schedule_orders } from "services/Middleware"

const UseGetScheduleOrder = () => {
  const { newCancelToken } = useCancelToken()

  const getScheduleOrder = async (body: any) => {
    const res = await post_get_schedule_orders(body, newCancelToken())
    return res
  }

  return {
    getScheduleOrder,
  }
}

export default UseGetScheduleOrder
